import type { ModuleTagEntry } from './index';

/** General Series module tags. */
export const tags: ModuleTagEntry[] = [
  'StudyInstanceUID',
  'SeriesInstanceUID',
  'Modality',
  'SeriesDescription',
  'SeriesNumber',
  'SeriesDate',
  'SeriesTime',
  'AcquisitionDate',
  'AcquisitionTime',
];
